export default __webpack_public_path__ + "static/media/checked.df5bdd17.svg";